import type {DomainCountry} from '@getmoss/moss-analytics'
import {track as trackMossAnalytics} from '@getmoss/moss-analytics'
import {PrismicNextImage, PrismicNextLink} from '@prismicio/next/pages'
import cn from 'classnames'
import {useLinkResolver} from 'prismicio'
import type {LinksColumnSliceLinksColumnV2PrimaryPromoCardItem} from 'prismicio-types'
import {EVENTS, track} from 'src/common/helpers'
import {Icon} from 'src/common/Icon'

type PromoCardProps = {
  promoCard: LinksColumnSliceLinksColumnV2PrimaryPromoCardItem
  componentIndex: number
  pageUid: string
  domainCountry: DomainCountry
}

export const PromoCard = ({promoCard, componentIndex, pageUid, domainCountry}: PromoCardProps) => {
  const {linkResolver} = useLinkResolver()

  return (
    <div
      className={cn('group max-lg:px-4', {
        'max-lg:hidden': promoCard.hidden_in_mobile,
      })}
    >
      <PrismicNextLink
        href={linkResolver(promoCard.link)}
        className="flex w-full gap-3 rounded-[4px] border border-black/[10%] bg-moss-white p-2 group-hover:bg-moss-grey-100"
        onClick={() => {
          track({
            event: EVENTS.CLICK,
            dataType: `order-${componentIndex}`,
            location: 'main-nav-drop-down',
            mktgId: `promo-card`,
            pageName: pageUid,
          })

          trackMossAnalytics({
            event: 'interaction',
            interaction: {
              element: `promo-card-${componentIndex}`,
              elementText: promoCard.link.text || '',
              location: 'nav-bar-dropdown',
              type: 'click',
            },
            page: {
              type: pageUid,
              domainCountry,
            },
          })
        }}
      >
        <div className="relative flex size-8 min-w-8 items-center justify-center rounded-[4px] bg-moss-blue">
          <PrismicNextImage field={promoCard.icon} className="size-4 brightness-0 invert" />
          <div className="pointer-events-none absolute inset-0 rounded-[4px] border border-black/[10%]" />
        </div>
        <div className="flex w-full items-center justify-between">
          <span className="text-[13px] leading-[normal] text-moss-black">{promoCard.link.text}</span>
          <Icon name="arrow" className="h-full w-[9px] text-black" />
        </div>
      </PrismicNextLink>
    </div>
  )
}
